import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";
import First from './First';
import Second from './Second';
import PowerSeries from './PowerSeries';
import Laplace from "./Laplace";
import ODEs from "./ODEs";
import Fourier from "./Fourier";
import ZTransforms from "./ZTransforms";

const ChangeComponents = {
    first: First,
    second: Second,
    powerseries: PowerSeries,
    laplace: Laplace,
    odes: ODEs,
    fourier: Fourier,
    ztransform: ZTransforms,

  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }